export const PRODUCT_VARIANT_FIELD_NAME = 'product-variant-sizing';
export const PRODUCT_VARIANT_SECTION_NAME = 'Size';
